import Component from 'vue-class-component'
import Vue from 'vue'
import RichMenuButton from "./RichMenuButton.vue";

@Component({
  name: 'icon-button',
  props: ['commands', 'isActive'],
  components: {'rich-button': RichMenuButton}
})
export default class IconButton extends Vue {
}
